import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const roreSuppliersRoutes = [
  {
    path: 'suppliers',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Suppliers')
      },
      permissions: ['READ_RORE_SUPPLIERS']
    },
    children: [
      {
        path: '',
        name: 'roreSuppliersList',
        component: wrapLegacyRoute('roreSuppliersController', 'list')
      },
      {
        path: 'create',
        name: 'roreSupplierCreate',
        component: wrapLegacyRoute('roreSuppliersController', 'create')
      },
      {
        path: ':supplierId(\\d+)',
        name: 'roreSupplierDetails',
        component: wrapLegacyRoute('roreSuppliersController', 'details')
      }
    ]
  }
];

export default roreSuppliersRoutes;
